export const blockIconsBusinessandpaymentsShoppingBasketNew = (
	<span className='material-symbols-outlined'>shopping_basket</span>
);
